
























































































































































































































import Wave from '@/components/Wave.vue';
import { translateError } from '@/i18n';

export default {
	name: 'ActionHandler',
	components: { Wave },
	data() {
		const validateConfirm = (rule, value, callback) => {
			if (value !== this.form.password) {
				callback(new Error(this.$t('actionHandler.validation.passwordsDoNotMatch')));
			} else {
				callback();
			}
		};
		return {
			state: 'loading' as
				| 'loading'
				| 'verify-success'
				| 'reset-form'
				| 'reset-success'
				| 'signin-email'
				| 'signin-set-password'
				| 'signin-success'
				| 'expired'
				| 'error',
			errorMessage: '',
			userEmail: '',
			oobCode: '',
			redirectUri: '',
			enterpriseId: '',
			copied: false,
			mode: '',
			tenantId: '',
			countdown: 5,
			submitting: false,
			resending: false,
			resent: false,
			inputEmail: '',
			form: {
				password: '',
				confirm: '',
			},
			signinForm: {
				email: '',
			},
			setPasswordForm: {
				password: '',
				confirm: '',
			},
			rules: {
				password: [
					{ required: true, message: this.$t('actionHandler.validation.passwordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('actionHandler.validation.passwordMin'), trigger: ['blur', 'change'] },
				],
				confirm: [
					{ required: true, message: this.$t('actionHandler.validation.repeatPassword'), trigger: 'blur' },
					{ validator: validateConfirm, trigger: 'blur' },
				],
			},
			signinRules: {
				email: [
					{ required: true, message: this.$t('actionHandler.validation.emailRequired'), trigger: 'blur' },
					{ type: 'email', message: this.$t('actionHandler.validation.emailInvalid'), trigger: ['blur', 'change'] },
				],
			},
			setPasswordRules: {
				password: [
					{ required: true, message: this.$t('actionHandler.validation.passwordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('actionHandler.validation.passwordMin'), trigger: ['blur', 'change'] },
				],
				confirm: [
					{ required: true, message: this.$t('actionHandler.validation.repeatPassword'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (value !== this.setPasswordForm.password) {
								callback(new Error(this.$t('actionHandler.validation.passwordsDoNotMatch')));
							} else {
								callback();
							}
						},
						trigger: 'blur',
					},
				],
			},
		};
	},
	computed: {
		progressPct(): number {
			return Math.round(((5 - this.countdown) / 5) * 100);
		},
	},
	watch: {
		'signinForm.email'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.signinForm.email = newValue.toLowerCase();
		},
	},
	methods: {
		getGaClientIdFromCookie(): string | null {
			try {
				const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
				if (!match) return null;
				const parts = match[1].split('.');
				if (parts.length < 4) return null;
				return `${parts[2]}.${parts[3]}`;
			} catch (e) {
				return null;
			}
		},
		getGaClientId(): Promise<string | null> {
			return new Promise(resolve => {
				const fallback = () => resolve(this.getGaClientIdFromCookie());
				const timeout = setTimeout(fallback, 1500);
				try {
					if (typeof (window as any).gtag !== 'function') {
						clearTimeout(timeout);
						return fallback();
					}
					(window as any).gtag('get', process.env.VUE_APP_measurementId, 'client_id', (clientId: string) => {
						clearTimeout(timeout);
						resolve(clientId || this.getGaClientIdFromCookie());
					});
				} catch (e) {
					clearTimeout(timeout);
					fallback();
				}
			});
		},
		startRedirectCountdown(email: string, redirectUri: string): void {
			const target = `${redirectUri}?email=${encodeURIComponent(email)}&validate=true`;
			const timer = setInterval(() => {
				this.countdown -= 1;
				if (this.countdown <= 0) {
					clearInterval(timer);
					window.location.href = target;
				}
			}, 1000);
		},
		openDownload(): void {
			window.location.href = 'https://rambox.app/download/';
		},
		copyEnterpriseId(): void {
			if (!this.enterpriseId) return;
			navigator.clipboard.writeText(this.enterpriseId).then(() => {
				this.copied = true;
				setTimeout(() => {
					this.copied = false;
				}, 2000);
			});
		},
		async resendVerification(): Promise<void> {
			const email = this.userEmail || this.inputEmail;
			if (!email) return;
			this.resending = true;
			try {
				await this.$firebase.functions().httpsCallable('sendVerificationEmail')({
					email,
					tenantId: this.tenantId,
				});
				this.resent = true;
			} catch (e) {
				console.error('resendVerification error', e);
			} finally {
				this.resending = false;
			}
		},
		async handleVerify(oobCode: string, tenantId: string, email: string, redirectUri: string): Promise<void> {
			if (tenantId) this.$firebase.auth().tenantId = tenantId;
			if (!email) {
				const info = await this.$firebase.auth().checkActionCode(oobCode);
				email = info.data.email || '';
				this.userEmail = email;
			}
			await this.$firebase.auth().applyActionCode(oobCode);
			this.state = 'verify-success';

			const clientId = await this.getGaClientId();
			if (clientId && typeof window.gtag === 'function') {
				try {
					window.gtag('event', 'signed_up_validated', { client_id: clientId });
				} catch (e) {
					console.error('gtag event error', e);
				}
			}
			try {
				await this.$firebase.functions().httpsCallable('userValidated')({ email });
			} catch (e) {
				console.error('userValidated error', e);
			}

			if (redirectUri) {
				this.startRedirectCountdown(email, redirectUri);
			}
		},
		async handleResetInit(oobCode: string, tenantId: string): Promise<void> {
			if (tenantId) this.$firebase.auth().tenantId = tenantId;
			const email = await this.$firebase.auth().verifyPasswordResetCode(oobCode);
			this.userEmail = email;
			this.state = 'reset-form';
		},
		async handleSignIn(tenantId: string, redirectUri: string): Promise<void> {
			if (tenantId) this.$firebase.auth().tenantId = tenantId;
			const fullUrl = window.location.href;
			if (!this.$firebase.auth().isSignInWithEmailLink(fullUrl)) {
				this.errorMessage = this.$t('actionHandler.errors.invalidLink');
				this.state = 'error';
				return;
			}
			const savedEmail = window.localStorage.getItem('emailForSignIn');
			if (savedEmail) {
				await this.completeSignIn(savedEmail, fullUrl, redirectUri);
			} else {
				this.state = 'signin-email';
			}
		},
		async completeSignIn(email: string, url: string, redirectUri: string): Promise<void> {
			await this.$firebase.auth().signInWithEmailLink(email, url);
			window.localStorage.removeItem('emailForSignIn');
			this.userEmail = email;
			this.redirectUri = redirectUri;
			try {
				const parsedUrl = new URL(redirectUri);
				const segment = parsedUrl.pathname.replace(/^\//, '').split('/')[0];
				if (segment) this.enterpriseId = segment;
			} catch (e) {
				// continueUrl not parseable, leave enterpriseId empty
			}
			this.state = 'signin-set-password';
		},
		startSignInRedirect(): void {
			const redirectUri = this.redirectUri;
			if (!redirectUri) return;
			this.countdown = 5;
			const timer = setInterval(() => {
				this.countdown -= 1;
				if (this.countdown <= 0) {
					clearInterval(timer);
					window.location.href = redirectUri;
				}
			}, 1000);
		},
		async submitSetPassword(): Promise<void> {
			try {
				const valid = await (this.$refs.setPasswordForm as any).validate();
				if (!valid) return;
			} catch {
				return;
			}
			this.submitting = true;
			try {
				const user = this.$firebase.auth().currentUser;
				if (!user) throw new Error(this.$t('actionHandler.errors.noAuthenticatedUser'));
				await user.updatePassword(this.setPasswordForm.password);
				await this.$firebase.functions().httpsCallable('completeEmailInvitation')({
					email: this.userEmail,
					organization: this.enterpriseId,
					tenantId: this.tenantId,
				});
				this.state = 'signin-success';
			} catch (error) {
				console.error(error);
				this.errorMessage = translateError(error, this.$t('actionHandler.errors.couldNotSetPassword'));
				this.state = 'error';
			} finally {
				this.submitting = false;
			}
		},
		async submitSignIn(): Promise<void> {
			try {
				const valid = await (this.$refs.signinForm as any).validate();
				if (!valid) return;
			} catch {
				return;
			}
			this.submitting = true;
			try {
				await this.completeSignIn(this.signinForm.email, window.location.href, this.redirectUri);
			} catch (error) {
				console.error(error);
				if (error.code === 'auth/expired-action-code') {
					this.state = 'expired';
				} else if (error.code === 'auth/invalid-email') {
					this.errorMessage = this.$t('actionHandler.errors.emailMismatch');
					this.state = 'error';
				} else {
					this.errorMessage = translateError(error, this.$t('actionHandler.errors.signInFailed'));
					this.state = 'error';
				}
			} finally {
				this.submitting = false;
			}
		},
		async submitReset(): Promise<void> {
			try {
				const valid = await (this.$refs.resetForm as any).validate();
				if (!valid) return;
			} catch {
				return;
			}
			this.submitting = true;
			try {
				await this.$firebase.auth().confirmPasswordReset(this.oobCode, this.form.password);
				this.state = 'reset-success';
			} catch (error) {
				console.error(error);
				if (error.code === 'auth/expired-action-code') {
					this.state = 'expired';
				} else {
					this.errorMessage = translateError(error, this.$t('actionHandler.errors.couldNotReset'));
					this.state = 'error';
				}
			} finally {
				this.submitting = false;
			}
		},
		async init(): Promise<void> {
			// Firebase sometimes HTML-encodes '&' as '&amp;' in email links
			const rawSearch = window.location.search;
			const fixedSearch = rawSearch.replace(/&amp%3B/gi, '&').replace(/&amp;/gi, '&');
			const params = new URLSearchParams(fixedSearch);

			const oobCode = params.get('oobCode') || '';
			const mode = params.get('mode') || '';
			const tenantId = params.get('tenantId') || '';
			const email = params.get('email') || '';
			const redirectUri = params.get('redirect_uri') || params.get('continueUrl') || '';

			this.oobCode = oobCode;
			this.redirectUri = redirectUri;
			this.userEmail = email;
			this.mode = mode;
			this.tenantId = tenantId;

			if (!oobCode || !['verifyEmail', 'resetPassword', 'signIn'].includes(mode)) {
				this.errorMessage = this.$t('actionHandler.errors.invalidLink');
				this.state = 'error';
				return;
			}

			try {
				if (mode === 'verifyEmail') {
					await this.handleVerify(oobCode, tenantId, email, redirectUri);
				} else if (mode === 'resetPassword') {
					await this.handleResetInit(oobCode, tenantId);
				} else if (mode === 'signIn') {
					await this.handleSignIn(tenantId, redirectUri);
				}
			} catch (error) {
				console.error(error);
				if (error.code === 'auth/expired-action-code') {
					this.state = 'expired';
				} else {
					this.errorMessage = translateError(error, this.$t('actionHandler.errors.linkInvalidOrUsed'));
					this.state = 'error';
				}
			}
		},
	},
	mounted() {
		this.init();
	},
};
